import React from 'react'
import { IconLock } from '@tabler/icons-react'

const Lock = () => {
  return <IconLock className=" h-5 w-5 border-2 border-yellow-200 bg-yellow-100 text-amber-700 rounded-md p-0.25" />
}

export default Lock
